import React from 'react'

export default class MessageAlertModal extends React.Component{
  constructor(props){
    super(props);
  };

  render(){
    return(
      <div className={`alert alert-dismissable ${this.props.additional_classes ? this.props.additional_classes : ''}`}>
        {`${this.props.message + ' '} `}
        {this.props.show_archive_warning == true 
          ?  <span className="ss-settings"></span> 
          : null
        } 
      </div>

    );
  };
};
